<div class="d-flex flex-row">
  <div
    class="row margin-top-m"
    *ngIf="permissionObj['GLOBAL_ENG_SubmissionDetails_ChangeCode_Enable']"
  >
    <div class="col-12 d-flex">
      <span class="icon-required-yellow" *ngIf="showEditWbsChargeCode"> </span>
      <span class="eclipse-small-header-grey text-align-left"
        >Charge code (WBS):</span
      >
    </div>
    <div>
      <ng-container
        *ngIf="
          showEditWbsChargeCode &&
            permissionObj['GLOBAL_ENG_SubmissionDetails_ChangeCode_Enable'] &&
            isSubmissionStatusDraft;
          else wbsChargeCodeSelected
        "
      >
        <div class="col-12 padding-top-xs">
          <div class="search-box" id="wbsChargeCodeSearch">
            <dds-search
              [size]="searchOptions.size ?? emptyString"
              [customClass]="searchOptions.customClass ?? emptyString"
              [icon]="searchOptions.icon || 'dds-icon_search'"
              (fieldCleared)="fieldCleared()"              
            >
              <input
                ddsSearch
                [placeholder]="searchOptions.placeholder ?? emptyString"
                [(ngModel)]="chargeCode"
                (ngModelChange)="findWbsChargeCode($event)"
                [maxlength]="number_11"
              />
            </dds-search>
            <div *ngIf="isSpinnerVisible" class="spinner-inside-input absolute">
              <dds-spinner
                [size]="spinnerOptions.size ?? _EMPTY"
                [theme]="spinnerOptions.theme ?? _EMPTY"
                [customClass]="spinnerOptions.customClass ?? _EMPTY"
                [isInverse]="spinnerOptions.isInverse ?? false"
                [thickness]="spinnerOptions.thickness ?? _EMPTY"
              ></dds-spinner>
            </div>
          </div>
          <div
            *ngIf="showDropdown"
            class="list-of-oppportunities d-flex flex-column padding-xs margin-top-xs absolute box-shadow-xs col-8"
            (scroll)="fetchMoreWbsResult($event)"
          >
            <div *ngIf="searchList.length > 0; else noWbsFound">
              <div *ngFor="let item of searchList">
                <div
                  class="opportunity-items d-flex flex-column"
                  (click)="onWbsChargeCodeSelect(item)"
                >
                  <div class="opportunity-details text-align-left">
                    <span class="opportunity-details-name">
                      {{ item }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #noWbsFound>
              <div class="no-users-found">
                {{ notFound }}
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
      <ng-template class="col-8 padding-top-xs d-flex" #wbsChargeCodeSelected>
        <span>{{ chargeCode }}</span>
        <span
          class="dds-icon dds-icon_copy__l__stroke icon margin-left-xs cursor-clickable"
          aria-label="Copy"
          aria-placeholder="Copy"
          title="Copy"
          (click)="clipboardCopy()"
        ></span>

        <span
          *ngIf="
            permissionObj['GLOBAL_ENG_SubmissionDetails_ChangeCode_Enable'] &&
            isSubmissionStatusDraft
          "
          class="dds-icon dds-icon_edit__s__filled margin-left-xs cursor-clickable"
          aria-label="edit wbs charge code"
          aria-placeholder="edit wbs charge code"
          title="edit wbs charge code"
          (click)="editWBSChargeCode()"
        ></span>
      </ng-template>
    </div>
  </div>
  <div
    class="row margin-top-m"
    *ngIf="
      showDescriptionAndArchive() &&
      permissionObj['GLOBAL_ENG_SubmissionDetails_WBSDescription_Visible']
    "
  >
    <div>
      <span class="eclipse-small-header-grey text-align-left"
        >WBS Description</span
      >
    </div>

    <div class="col-12">
      <div class="textarea-container">
        <div class="row padding-top-xs">
          <div class="col-12">
            {{ wbsDescription ? wbsDescription : defaultForEmptyFields }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="permissionObj['GLOBAL_ENG_SubmissionDetails_Archive_Visible']">
    <div class="row margin-top-m" *ngIf="showDescriptionAndArchive()">
      <div class="col-12 d-flex">
        <span
          class="icon-required-yellow"
          *ngIf="selectedArchive === emptyString"
        ></span>
        <span class="eclipse-small-header-grey text-align-left">Archive:</span>
      </div>
      <div class="col-12">
        <div
          *ngIf="
            showArchiveDropdown && isSubmissionStatusDraft;
            else showArchiveDetails
          "
          class="col-12"
        >
          <dds-select
            [placeholder]="archiveSelectOptions.placeholder ?? _EMPTY"
            [list]="actionDropdownList"
            [stickerMaxHeight]="'40vh'"
            [(ngModel)]="selectedArchive"
            (ngModelChange)="onArchiveSelect()"
            [disabled]="
              !permissionObj['GLOBAL_ENG_SubmissionDetails_Archive_Enable']
            "
          ></dds-select>
        </div>
        <ng-template #showArchiveDetails>
          <div class="col-12">
            <div class="textarea-container">
              <div class="row padding-top-xs">
                <div>
                  {{ archiveDescription }}
                  <span
                    *ngIf="
                      permissionObj[
                        'GLOBAL_ENG_SubmissionDetails_Archive_Enable'
                      ] && isSubmissionStatusDraft
                    "
                    class="dds-icon dds-icon_edit__s__filled margin-left-xs cursor-clickable"
                    aria-label="Edit Archive Details"
                    aria-placeholder="Edit Archive Details"
                    title="Edit Archive Details"
                    (click)="editArchiveDetails()"
                  ></span>
                </div>
              </div>
            </div></div
        ></ng-template>
        <span
          *ngIf="isArchiveError && isSubmissionStatusDraft"
          class="font-size-11 color-red padding-top-xs padding-bottom-xs"
          >Archive not listed for {{ chargeCode }}</span
        >
      </div>
    </div>
  </div>
</div>
